import React from 'react';
import { DancingHeadline } from 'js/components/DancingHeadline';
import {
  BestTreatmentsBadge,
  BestTreatmentsBadgeStyle,
} from 'js/components/BestTreatmentsBadge';
import { CmsBestForBrowsePage } from 'js/model/cms/cms-best-for-browse-page';
import { CmsCalendar } from 'js/model/cms/cms-calendar';
import { substitute, substituteWithDictionary } from 'js/helpers/i18n';
import { BestForBrowsePageOutput } from 'js/model/rainbow/best-for-browse-page/BestForBrowsePageOutput';
import { WaveBoi } from 'js/components/WaveBoi/WaveBoi';
import styles from './Header.module.css';

interface Props {
  badgeLabel: string;
  badgeTooltip: string;
  headline: string;
  date: string;
  introduction: string;
}

export function Header(props: Props): React.ReactElement {
  return (
    <div className={styles.container}>
      <div className={styles.pageWidthConstraint}>
        <div className={styles.content}>
          <BestTreatmentsBadge
            label={props.badgeLabel}
            style={BestTreatmentsBadgeStyle.Outline}
            tooltip={props.badgeTooltip}
          />
          <h1 className={styles.headline}>
            <DancingHeadline headline={props.headline} />
          </h1>
          <time className={styles.date}>{props.date}</time>
          <p className={styles.introduction}>{props.introduction}</p>
          <div className={styles.waveBoiOuterContainer}>
            <div className={styles.waveBoi}>
              <WaveBoi />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function createHeaderViewModel(
  pageData: BestForBrowsePageOutput,
  cms: CmsBestForBrowsePage['page']['best-for-browse']['header'],
  commonCms: CmsBestForBrowsePage['common']
): Props {
  const headlinePlaceholders = {
    venueCount: pageData.data.venues.length.toString(),
    treatment: pageData.data.treatment,
    location: pageData.data.location,
  };
  const headline = substituteWithDictionary(cms.title, headlinePlaceholders);

  const datePublished = new Date(pageData.data.datePublished);
  const datePlaceholders = {
    month:
      commonCms.calendar['month-names'][
        datePublished.getMonth() as keyof CmsCalendar['calendar']['month-names']
      ],
    year: datePublished.getFullYear().toString(),
  };
  const date = substituteWithDictionary(cms['date-template'], datePlaceholders);

  const introduction = substituteWithDictionary(
    cms.introduction,
    headlinePlaceholders
  );

  return {
    badgeLabel: substitute(
      commonCms.labels['btt-badge-singular'],
      pageData.data.treatment
    ),
    badgeTooltip: commonCms.labels['btt-badge-tooltip'],
    headline,
    date,
    introduction,
  };
}
